import request from "@/utils/request";

const getCaptcha = {
    
    get: (data) => {
        return request({
            url: 'common/getCaptcha',
            method: 'GET',
            data
        })
    },
    
}
export default getCaptcha;